var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Print",
    clipPath: "url(#clip0_24506_17641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7998 12.8101C6.57889 12.8101 6.3998 12.9981 6.3998 13.2301C6.3998 13.462 6.57889 13.6501 6.7998 13.6501H9.1998C9.42072 13.6501 9.5998 13.462 9.5998 13.2301C9.5998 12.9981 9.42072 12.8101 9.1998 12.8101H6.7998Z",
    fill: "#FEAB3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3998 11.1301C6.3998 10.8981 6.57889 10.7101 6.7998 10.7101H9.1998C9.42072 10.7101 9.5998 10.8981 9.5998 11.1301C9.5998 11.362 9.42072 11.5501 9.1998 11.5501H6.7998C6.57889 11.5501 6.3998 11.362 6.3998 11.1301Z",
    fill: "#FEAB3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 3.36009V1.68009C11.9998 1.21617 11.6416 0.840088 11.1998 0.840088H4.7998C4.35798 0.840088 3.9998 1.21617 3.9998 1.68009V3.36009H3.1998C1.87432 3.36009 0.799805 4.48833 0.799805 5.88009V10.9201C0.799805 12.3118 1.87432 13.4401 3.19981 13.4401H3.9998V15.1201C3.9998 15.584 4.35798 15.9601 4.7998 15.9601H11.1998C11.6416 15.9601 11.9998 15.584 11.9998 15.1201V13.4401H12.7998C14.1253 13.4401 15.1998 12.3118 15.1998 10.9201V5.88009C15.1998 4.48833 14.1253 3.36009 12.7998 3.36009H11.9998ZM5.1998 2.10009V3.36009H10.7998V2.10009H5.1998ZM10.7998 9.66009H5.1998V14.7001H10.7998V9.66009ZM3.9998 5.88009C3.77889 5.88009 3.5998 6.06813 3.5998 6.30009C3.5998 6.53205 3.77889 6.72009 3.9998 6.72009H4.7998C5.02072 6.72009 5.1998 6.53205 5.1998 6.30009C5.1998 6.06813 5.02072 5.88009 4.7998 5.88009H3.9998Z",
    fill: "#FEAB3D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24506_17641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIconOrange);
export default __webpack_public_path__ + "static/media/print-icon-orange.9b6523eb4a4fad33434bc958ae8c1c05.svg";
export { ForwardRef as ReactComponent };